import React from "react";
import { useDispatch } from "react-redux";
import Step6 from "./Step6"
import { Formik } from 'formik';
import * as Yup from 'yup';
import { formSupplierOperations } from "state/ducks/formSupplier";

// Renseignements relatifs à la capacité technique et professionnelle du candidat individuel ou du membre du groupement
const Step6Container = (props) => {

  const {
    formRef,
    initialValues
  } = props

  const dispatch = useDispatch();

  // Schéma de validation front
  const validationSchema = Yup.object().shape({
    economicCapacity: Yup.array().of(
      Yup.object().shape({
        organization: Yup.string().nullable().required("Ce champ est requis"),
        y1Revenue:  Yup.string().nullable().required("Ce champ est requis"),
        y1PartOfRevenue:  Yup.string().nullable().required("Ce champ est requis"),
        y2Revenue:  Yup.string().nullable().required("Ce champ est requis"),
        y2PartOfRevenue:  Yup.string().nullable().required("Ce champ est requis"),
        y3Revenue:  Yup.string().nullable().required("Ce champ est requis"),
        y3PartOfRevenue:  Yup.string().nullable().required("Ce champ est requis"),
      })),
  })

  return (
    <>
    <Formik
       initialValues={initialValues.step6}
       validationSchema={validationSchema}
       onSubmit={values => {dispatch(formSupplierOperations.setStep6(values, initialValues.id))}}
     >
       {({ errors, touched, values, setFieldValue }) => (
         <>
          <Step6 formRef={formRef} values={values} setFieldValue={setFieldValue} touched={touched} errors={errors} initialValues={initialValues} />
         </>
       )}
     </Formik>
     </>
  );

};

Step6Container.propTypes = {
};

Step6Container.defaultProps = {

};

export default Step6Container;
